import { WSCard } from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { useQueryInternalAccountBalance } from "../../../query/banking/queries/useQueryInternalAccountBalance";
import { useQueryInternalAccounts } from "../../../query/banking/queries/useQueryInternalAccounts";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryPayoutSettings } from "../../../query/payments/queries";
import { PATH_PLATFORM_BALANCE } from "../paths";
import { selectorIsPlatformBalanceAccount } from "../selectors/selectorIsPlatformBalanceAccount";

export const WidgetPlatformBalance: React.FC = () => {
  const history = useHistory();
  const userId = useUserId();
  const queryInternalAccounts = useQueryInternalAccounts();
  const queryPayoutSettings = useQueryPayoutSettings(userId);

  const apPayoutAccount = useMemo(() => {
    if (!queryInternalAccounts.data || !queryPayoutSettings.data) {
      return;
    }

    return queryInternalAccounts.data.find(internalAccount =>
      selectorIsPlatformBalanceAccount(
        internalAccount,
        queryPayoutSettings.data
      )
    );
  }, [queryInternalAccounts.data, queryPayoutSettings.data]);

  const queryInternalAccountBalance = useQueryInternalAccountBalance(
    apPayoutAccount?.internalAccountId!,
    {
      enabled: !!apPayoutAccount
    }
  );

  if (!apPayoutAccount || !queryInternalAccountBalance.data) {
    return null;
  }

  return (
    <WSCard
      divider
      header={{
        label: "Platform balance",
        value: {
          value: formatMoney(
            queryInternalAccountBalance.data.balance,
            apPayoutAccount.currency
          )
        }
      }}
      actions={{
        alignment: "left",
        buttons: [
          {
            kind: "Link",
            label: "View details",
            onClick: () => {
              history.push(PATH_PLATFORM_BALANCE);
            }
          }
        ]
      }}
    />
  );
};
